import $x from '@/utils/$x';

/**
 * 练阶段（即原来的运动目标）和运动风格字段   阶段枚举
 * @param {*} params
 * @returns
 */
export async function getFitnessTargetAndStyle(params) {
  return $x.post('/sidebar/report/getFitnessTargetAndStyle', params);
}

/**
 * 分页查询计划模板列表
 * @param {*} params
 * @returns
 */
export async function getHealthPlanTemplateByCond(params) {
  return $x.post('/healthplan/getHealthPlanTemplateByCond', params);
}

/**
 * 获取课程阶段类型枚举
 * @param {*} params
 * @returns
 */
export async function getCoursePhaseType(params) {
  return $x.post('/healthplan/getCoursePhaseType', params);
}

/**
 * 添加计划模板
 * @param {*} params
 * @returns
 */
export async function addLittaHealthPlanTemplate(params) {
  return $x.post('/healthplan/addLittaHealthPlanTemplate', params);
}

/**
 * 修改计划模板
 * @param {*} params
 * @returns
 */
export async function updateLittaHealthPlanTemplate(params) {
  return $x.post('/healthplan/updateLittaHealthPlanTemplate', params);
}

/**
 * 上下架计划模板
 * @param {*} params
 * @returns
 */
export async function enableOrDisableHealthPlanTemplate(params) {
  return $x.post('/healthplan/enableOrDisableHealthPlanTemplate', params);
}

/**
 * 查询计划模板详情
 * @param {*} params
 * @returns
 */
export async function getHealthPlanTemplateInfoById(params) {
  return $x.post('/healthplan/getHealthPlanTemplateInfoById', params);
}

/**
 * 添加子阶段
 * @param {*} params
 * @returns
 */
export async function addSubsPlanTemplate(params) {
  return $x.post('/healthplan/addSubsPlanTemplate', params);
}

/**
 * 修改子阶段
 * @param {*} params
 * @returns
 */
export async function updateSubsPlanTemplate(params) {
  return $x.post('/healthplan/updateSubsPlanTemplate', params);
}

/**
 * 删除子阶段
 * @param {*} params
 * @returns
 */
export async function delSubsPlanTemplate(params) {
  return $x.post('/healthplan/delSubsPlanTemplate', params);
}

/**
 * 添加模板课程
 * @param {*} params
 * @returns
 */
export async function addPlanCourseTemplate(params) {
  return $x.post('/healthplan/addPlanCourseTemplate', params);
}

/**
 * 新增动作序列
 * @param {*} params
 * @returns
 */
export async function addActionSequence(params) {
  return $x.post('/healthplan/addActionSequence', params);
}

/**
 * 更新动作序列
 * @param {*} params
 * @returns
 */
export async function updateActionSequence(params) {
  return $x.post('/healthplan/updateActionSequence', params);
}

/**
 * 删除动作序列
 * @param {*} params
 * @returns
 */
export async function deleteActionSequence(params) {
  return $x.post('/healthplan/deleteActionSequence', params);
}

/**
 * 动作序列排序
 * @param {*} params
 * @returns
 */
export async function updateActionSeqPriority(params) {
  return $x.post('/healthplan/updateActionSeqPriority', params);
}

/**
 * 计划模板详情页的排序接口 排序计划课程模板 phase排序
 * @param {*} params
 * @returns
 */
export async function sortPlanCourseTemplate(params) {
  return $x.post('/healthplan/sortPlanCourseTemplate', params);
}

/**
 * 查询课程详情
 * @param {*} params
 * @returns
 */
export async function queryPlanCourseTemplate(params) {
  return $x.post('/healthplan/queryPlanCourseTemplate', params);
}

/**
 * 删除计划课程模板
 * @param {*} params
 * @returns
 */
export async function deletePlanCourseTemplate(params) {
  return $x.post('/healthplan/deletePlanCourseTemplate', params);
}

/**
 * 删除课程训练阶段
 * @param {*} params
 * @returns
 */
export async function deleteCourseTemplatePhase(params) {
  return $x.post('/healthplan/deleteCourseTemplatePhase', params);
}

/**
 * 添加课程训练阶段
 * @param {*} params
 * @returns
 */
export async function addCourseTemplatePhase(params) {
  return $x.post('/healthplan/addCourseTemplatePhase', params);
}

/**
 * 更新计划课程模板 ID：aXYGgqJ2
 * @param {*} params
 * @returns
 */
export async function updatePlanCourseTemplate(params) {
  return $x.post('/healthplan/updatePlanCourseTemplate', params);
}

/**
 * 视频管理
 */

export async function getVideoList(params) {
  return $x.post('/media/findMediaByPage', params);
}

/**
 * 更新课程训练阶段 ID：kXONjL58
 */

export async function updateCourseTemplatePhase(params) {
  return $x.post('/healthplan/updateCourseTemplatePhase', params);
}

/**
 * 排序课程模板阶段
 */

export async function sortCourseTemplatePhase(params) {
  return $x.post('/healthplan/sortCourseTemplatePhase', params);
}

/**
 * 排序课程模板阶段
 */

export async function getSubsPlanTemplateByTemplateId(params) {
  return $x.post('/healthplan/getSubsPlanTemplateByTemplateId', params);
}

/**
 * 训练部位
 */
export async function listTrainingParts(params) {
  return $x.get('/healthplan/listTrainingParts', params);
}
